<p>{{ 'popins.logout.text' | translate }}</p>
@if (leavesProject) {
  <p class="logout-warning">{{ 'popins.logout.leave-project' | translate }}</p>
}
<div class="logout-actions">
  <ng-casto-button
    class="secondary"
    (click)="modal.close()"
    [label]="'popins.logout.cancel' | translate"></ng-casto-button>
  <ng-casto-button class="primary" (click)="signout()" [label]="'popins.logout.confirm' | translate"></ng-casto-button>
</div>
